import { Button, Dialog } from "../components/ui";

const MessageThreadDrawer = ({
  messageId,
  messages,
  onOpenChange,
  onMarkReplied,
}: {
  messageId: string | null;
  messages: any[];
  onOpenChange: (open: boolean) => void;
  onMarkReplied: (id: string) => Promise<void>;
}) => {
  const message = messages.find((item) => item.id === messageId) ?? null;
  return (
    <Dialog
      open={messageId !== null}
      onOpenChange={onOpenChange}
      title={message?.user.email ?? message?.user.username ?? "Inbox thread"}
      description="Audience conversations stay in a secondary drawer so the main queue can remain triage-focused."
      className="max-w-xl"
      showCloseButton
    >
      {message && (
        <div className="flex flex-col gap-4">
          <div className="rounded-sm border border-stroke p-4 dark:border-strokedark">
            <p className="text-sm text-neutral-700 dark:text-neutral-300">
              {message.content}
            </p>
          </div>
          <div className="flex justify-end gap-3">
            {!message.repliedAt && (
              <Button
                type="button"
                size="sm"
                className="rounded-sm"
                onClick={() => onMarkReplied(message.id)}
              >
                Mark replied
              </Button>
            )}
            <Button
              type="button"
              variant="outline"
              tone="neutral"
              size="sm"
              className="rounded-sm"
              onClick={() => onOpenChange(false)}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default MessageThreadDrawer;
